import { ERRORS } from '@/constants/errors';

import { matchCollateralOverflow, matchUnitReserveOutdated } from './matchers';

type ErrorPattern = {
  match: (message: string) => boolean;
  message: string;
};

const ERROR_PATTERNS: ErrorPattern[] = [
  {
    match: matchCollateralOverflow,
    message: ERRORS.GUARDIAN.ACTION_INVALID_COLLATERAL_OVERFLOW,
  },
  {
    match: matchUnitReserveOutdated,
    message: ERRORS.GUARDIAN.UNIT_RESERVE_OUTDATED,
  },
];

/**
 * Transform an arbitrary backend / SDK error into a human-readable message.
 * Returns a mapped message from ERRORS when a known pattern matches.
 */
export function toHumanReadableError(error: unknown): string | null {
  const message = getErrorMessage(error);

  if (!message) {
    return null;
  }

  for (const pattern of ERROR_PATTERNS) {
    if (pattern.match(message)) {
      return pattern.message;
    }
  }

  return null;
}

export function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (error && typeof error === 'object' && 'message' in error && typeof (error as { message: unknown }).message === 'string') {
    return (error as { message: string }).message;
  }

  if (error == null) {
    return '';
  }

  try {
    return String(error);
  } catch {
    return '';
  }
}
